import { init } from '@plausible-analytics/tracker'
import { envConfig } from '../constants';


const domain = envConfig.REACT_APP_DOMAIN_NAME;
const endpoint = envConfig.REACT_APP_PLAUSIBLE_API_HOST;

init({ domain, endpoint })